import { timezone } from '@/components/Const.ts'
import { DateTime } from 'luxon'

// formaterer en dato med tid og tidszone fra et json felt
export const formatDate = (value : string) : string | undefined => {
  if (value) {
    return DateTime.fromISO(value).setZone(timezone).toFormat('d/L/y')
  }
}
